/// <reference path="../../../../../../typings/index.d.ts" />

module Meevo.Plugins.SelfCheckInKiosk {


    import ModalTranslationModes = Meevo.Components.Modal.ModalTranslationModes;
    import DocsAndFormsService = Meevo.Plugins.DocsAndForms.DocsAndFormsService;
    import DocsAndFormsFormListModal = Meevo.Plugins.DocsAndForms.DocsAndFormsFormListModal;
    import DocsAndFormsApiService = Meevo.Plugins.DocsAndForms.DocsAndFormsApiService;

    class ClientInfoController {
        public static $inject = [
            'meevo.components.common.DataService',
            'meevo.plugins.selfCheckInKiosk.SelfCheckInKioskLogic',
            'meevo.AppSettings',
            'meevo.components.modal.ModalService',
            '$state',
            '$rootScope',
            'meevo.components.common.IdentityService',
            'meevo.plugins.docsAndForms.DocsAndFormsService',
            'meevo.plugins.docsAndForms.DocsAndFormsApiService',
        ];

        get clientDataToCheckIn() {
            return this.selfCheckInKioskLogic.clientDataToCheckin;
        }

        get checkInDisabled() {
            return false;
        }

        public get allowUpdateClient(): boolean {
            return this.selfCheckInKioskLogic.kioskSettings.allowClientToUpdateProfile;
        }

        constructor(protected dataService: Meevo.Components.CommonClasses.ICommonDataService,
                    protected selfCheckInKioskLogic: SelfCheckInKioskLogic,
                    protected appSettings: Meevo.Components.Common.IAppSettings,
                    protected modalService: Meevo.Components.Modal.ModalService,
                    protected $state: ng.ui.IStateService,
                    protected $rootScope: ng.IRootScopeService,
                    protected identityService: Meevo.Components.Common.IIdentityService,
                    protected docsAndFormsService: DocsAndFormsService,
                    protected docsAndFormsApiService: DocsAndFormsApiService) {

        }

        checkIn() {
            const appointmentServiceIds: string[] = this.selfCheckInKioskLogic
                .clientDataToCheckin
                .reduce((all, row) => {
                    return [...all, ...row.appointmentCheckInData.appointmentServices.map(r => r.id)]
                }, []);

            Promise.all([
                this.docsAndFormsApiService.getFormServiceConfig(appointmentServiceIds),
                this.selfCheckInKioskLogic.loadAdditionalEnhancements()
            ]).then(([config]) => {
                const hasUnSubmittedForms = config.reduce((res, current) => res || current.hasUnsubmittedForms, false)

                if (hasUnSubmittedForms && this.selfCheckInKioskLogic.kioskSettings.promptUnsubmittedForms) {
                    this.docsAndFormsService
                        .getUnSubmittedValidForms(appointmentServiceIds)
                        .then(forms => {
                            DocsAndFormsFormListModal
                                .show(this.modalService, {
                                    forms,
                                    formCollectionState: Meevo.Plugins.AppointmentBook.FormCollectionStateEnum.Checkin,
                                    appointmentServices: _.flatten(
                                        this.selfCheckInKioskLogic
                                            .clientDataToCheckin
                                            .map(row => row.appointmentServicesToCheckIn.map(r => r.appointmentService))
                                    ) as ISelfCheckinAppointment[],
                                    options: {
                                        showResend: false,
                                        showLaunch: false
                                    }
                                })
                                .then(() => {
                                    if (this.selfCheckInKioskLogic.kioskSettings.preventCheckinIfNotSubmittedForms) {
                                        this.$state.go(`${this.appSettings.ROUTE_NAMES.selfCheckInKiosk}.check-in-fail`);
                                    } else if (this.selfCheckInKioskLogic.enhancementsCount > 0) {
                                        this.$state.go(`${this.appSettings.ROUTE_NAMES.selfCheckInKiosk}.enhancements`);
                                    } else {
                                        this.$state.go(`${this.appSettings.ROUTE_NAMES.selfCheckInKiosk}.check-in-success`);
                                    }
                                });
                        });
                } else {
                    if (this.selfCheckInKioskLogic.enhancementsCount > 0) {
                        this.$state.go(`${this.appSettings.ROUTE_NAMES.selfCheckInKiosk}.enhancements`);
                    } else {
                        this.$state.go(`${this.appSettings.ROUTE_NAMES.selfCheckInKiosk}.check-in-success`);
                    }
                }
            });
        }

        public goToIntakeForm(clientId): void {
            this.selfCheckInKioskLogic
                .checkExistIntakeForm()
                .then((exists) => {
                    if (!exists) {
                        this.modalService.alert(this.identityService.current().isSingleLocation ? 'MESSAGE_NOT_CREATED_INTAKE_FORM' : 'MESSAGE_NOT_CREATED_INTAKE_FORM_CO', ModalTranslationModes.Translate, true);

                        return;
                    }

                    this.$rootScope.$broadcast(Meevo.Components.Common.Messages.GOTO_STATE, {
                        stateName: this.appSettings.ROUTE_NAMES.clientIntake,
                        stateParams: {
                            clientId: clientId,
                            fromState: this.appSettings.ROUTE_NAMES.selfCheckInKiosk
                        },
                    });

                    this.$rootScope.$on(Meevo.Components.Common.Messages.CLOSE_INTAKE_FORM, () => {
                        this.selfCheckInKioskLogic.updateClientsData();
                    });
                });
        }
    }


    angular.module('meevo.plugins.selfCheckInKiosk')
        .controller('meevo.plugins.selfCheckInKiosk.ClientInfoController', ClientInfoController);
}
